import {TenantType} from '../../_types/selectOptionsTypes/TenantType';

export const tenantOptions: Array<TenantType> = [
  {value: 'UNKNOWN', label: 'Unknown'},
  {value: 'SINGLE', label: 'Single'},
  {value: 'MULTI', label: 'Multi'},
];
